import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ReactComponent as CircleLogo } from '../../../assets/images/common/icons/circle-logo.svg'
import { signInUser } from '../../../actions/authActions'
import { showSideBar, showNavBar, setSideBarState } from '../../../actions/commonActions'
import { initializePendo } from '../../../utility/pendo'
import { identifyUser, trackEvent, EVENTS } from '../../../utility/analytics'
import SubmitButton from '../../common/buttons/SubmitButton'
import FormInput from '../Helpers/FormInput'
import FieldError from '../../common/FieldError'

import classes from './LogInPage.module.scss'
import { NAVIGATION } from '../../../misc/Constants'

const LogInPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [loader, setLoader] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const handleLogIn = () => {
    setLoader(true)

    const communityId = localStorage.getItem('communityId')
    const invitationId = localStorage.getItem('invitationId')
    dispatch(signInUser(email, password, communityId, invitationId))
      .then((response) => {
        initializePendo(window.pendo, response)

        const user = response.data?.user
        identifyUser(user)
        trackEvent(EVENTS.SIGNED_IN, { sign_in_count: user?.sign_in_count })

        dispatch(showSideBar(true))
        dispatch(showNavBar(true))
        dispatch(setSideBarState(NAVIGATION.COLLAPSED))

        const redirectUrl = localStorage.getItem('redirectUrl') || '/dashboard'
        const localStorageItems = ['redirectUrl', 'communityId', 'invitationId', 'guestAccessCode']
        localStorageItems.forEach(item => localStorage.removeItem(item))

        navigate(redirectUrl, { replace: true, state: { invitationFeedback: response.data.invitation_feedback } })
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.errors?.general?.at(0)
        if (errorMessage?.includes('confirm')) {
          navigate('/sign-up/email-verification-required', { replace: true, state: { from: 'log-in', email: email } })
        } else {
          setError(t('auth.login.incorrectEmailOrPassword'))
        }
      })
      .finally(() => {
        setLoader(false)
      })
  }

  return (
    <div className={classNames(classes.logInPage, 'd-flex')}>
      <aside className={classNames(classes.mainCard, 'd-flex flex-column justify-content-center align-items-center m-auto')}>
        <header className='d-flex flex-column justify-content-center align-items-center'>
          <CircleLogo className={classes.circleLogo} />
          <h2 className={classes.titleText}>{t('auth.login.title')}</h2>
        </header>

        <form className='row w-100 mt-2'>
          <div className='col-12 col-lg-6 offset-lg-3'>
            {error && <FieldError message={error} style={{ paddingBottom: '5px' }} general/>}

            <label htmlFor='email' className={classes.inputLabel}>
              {t('auth.login.emailOrUsernameLabel')} <span className='required-text'>*</span>
            </label>

            <FormInput
              name='email'
              type='text'
              onChange={(e) => { setEmail(e.target.value); setError('') }}
              value={email}
              symbol={<i className={classNames(classes.inputSymbol, 'fa fa-envelope')}/>}
            />

            <label htmlFor='password' className={classes.inputLabel}>
              {t('common.field.password')} <span className='required-text'>*</span>
            </label>

            <FormInput
              name='password'
              type='password'
              onChange={(e) => { setPassword(e.target.value); setError('') }}
              value={password}
              symbol={<i className={classNames(classes.inputSymbol, 'fa fa-lock')}/>}
              autoComplete='new-password'
            />

            <SubmitButton
              onClick={(e) => { e.preventDefault(); handleLogIn() }}
              buttonMessage={t('auth.login.logInButton')}
              buttonColor='orange-button'
              className={classes.logInButton}
              disabled={loader || !email || !password || !!error}
            />
          </div>
        </form>

      </aside>
    </div>
  )
}

export default LogInPage
